import { css } from 'styled-components';
export var generateColorMapDeviceCSS = (device, colorMap) => css(["", ""], p => colorMap ? css(["color:", ";&::selection{color:", ";}"], p.theme.colors[colorMap[device]], p.theme.colors[colorMap[device]]) : '');

var generateTypographyDefaultColorCSS = typographyType => css(["", ""], p => {
  var typographyDefaultColor = p.theme.typographyDefaultColors[typographyType];

  if (typographyDefaultColor) {
    return css(["color:", ";&::selection{color:", ";}"], p.theme.colors[typographyDefaultColor], p.theme.colors[typographyDefaultColor]);
  }

  return '';
});

var baseFontStyles = /*#__PURE__*/css(["font-family:", ",sans-serif;"], p => p.theme.fontFamily);
var baseDisplayStyles = /*#__PURE__*/css(["", ";font-weight:300;"], baseFontStyles);
export var display1Styles = /*#__PURE__*/css(["", ";font-size:92px;line-height:92px;letter-spacing:-1.5px;"], baseDisplayStyles);
export var display2Styles = /*#__PURE__*/css(["", ";font-size:84px;line-height:84px;letter-spacing:-1.3px;"], baseDisplayStyles);
export var display3Styles = /*#__PURE__*/css(["", ";font-size:76px;line-height:76px;letter-spacing:-1.4px;"], baseDisplayStyles);
export var display4Styles = /*#__PURE__*/css(["", ";font-size:60px;line-height:60px;letter-spacing:-1.3px;"], baseDisplayStyles);
export var display5Styles = /*#__PURE__*/css(["", ";font-size:56px;line-height:56px;letter-spacing:-1.3px;"], baseDisplayStyles);
export var display6Styles = /*#__PURE__*/css(["", ";font-size:48px;line-height:48px;letter-spacing:-1.3px;"], baseDisplayStyles);
export var display7Styles = /*#__PURE__*/css(["", ";font-size:36px;line-height:44px;letter-spacing:-1.3px;"], baseDisplayStyles);
export var display8Styles = /*#__PURE__*/css(["", ";font-size:32px;line-height:40px;letter-spacing:-1.3px;"], baseDisplayStyles);
var baseHeadingStyles = /*#__PURE__*/css(["", ";font-weight:500;"], baseFontStyles);
export var heading1Styles = /*#__PURE__*/css(["", ";font-size:60px;line-height:60px;letter-spacing:-1.3px;"], baseHeadingStyles);
export var heading2Styles = /*#__PURE__*/css(["", ";font-size:56px;line-height:56px;letter-spacing:-1px;"], baseHeadingStyles);
export var heading3Styles = /*#__PURE__*/css(["", ";font-size:48px;line-height:48px;letter-spacing:-1px;"], baseHeadingStyles);
export var heading4Styles = /*#__PURE__*/css(["", ";font-size:36px;line-height:40px;letter-spacing:-0.4px;"], baseHeadingStyles);
export var heading5Styles = /*#__PURE__*/css(["", ";font-size:32px;line-height:36px;letter-spacing:-0.4px;"], baseHeadingStyles);
export var heading6Styles = /*#__PURE__*/css(["", ";font-size:28px;line-height:32px;letter-spacing:-0.3px;"], baseHeadingStyles);
export var heading7Styles = /*#__PURE__*/css(["", ";font-size:24px;line-height:28px;letter-spacing:-0.3px;"], baseHeadingStyles);
export var heading8Styles = /*#__PURE__*/css(["", ";font-size:20px;line-height:24px;letter-spacing:-0.2px;"], baseHeadingStyles);
export var heading9Styles = /*#__PURE__*/css(["", ";font-size:16px;line-height:20px;letter-spacing:0.2px;"], baseHeadingStyles);
export var heading10Styles = /*#__PURE__*/css(["", ";font-size:15px;line-height:20px;letter-spacing:0.3px;"], baseHeadingStyles);
export var heading11Styles = /*#__PURE__*/css(["", ";font-size:14px;line-height:20px;letter-spacing:0.3px;"], baseHeadingStyles);
var baseBodyStyles = /*#__PURE__*/css(["", ";font-weight:400;"], baseFontStyles);
export var body1Styles = /*#__PURE__*/css(["", ";font-size:28px;line-height:32px;letter-spacing:-0.3px;"], baseBodyStyles);
export var body2Styles = /*#__PURE__*/css(["", ";font-size:24px;line-height:30px;letter-spacing:-0.3px;"], baseBodyStyles);
export var body3Styles = /*#__PURE__*/css(["", ";font-size:22px;line-height:30px;letter-spacing:-0.2px;"], baseBodyStyles);
export var body4Styles = /*#__PURE__*/css(["", ";font-size:18px;line-height:24px;letter-spacing:-0.2px;"], baseBodyStyles);
export var body5Styles = /*#__PURE__*/css(["", ";font-size:14px;line-height:20px;letter-spacing:0.3px;"], baseBodyStyles);
export var body6Styles = /*#__PURE__*/css(["", ";font-size:12px;line-height:18px;letter-spacing:0.3px;"], baseBodyStyles);
export var body7Styles = /*#__PURE__*/css(["", ";font-size:10px;line-height:16px;letter-spacing:0.4px;"], baseBodyStyles);
var baseAllCapsStyles = /*#__PURE__*/css(["", ";font-weight:500;text-transform:uppercase;"], baseFontStyles);
export var allCaps1Styles = /*#__PURE__*/css(["", ";font-size:14px;line-height:20px;letter-spacing:0.5px;"], baseAllCapsStyles);
export var allCaps2Styles = /*#__PURE__*/css(["", ";font-size:12px;line-height:16px;letter-spacing:0.5px;"], baseAllCapsStyles);
export var allCaps3Styles = /*#__PURE__*/css(["", ";font-size:11px;line-height:20px;letter-spacing:0.5px;", ";"], baseAllCapsStyles, generateTypographyDefaultColorCSS('allCaps3'));
export var allCaps4Styles = /*#__PURE__*/css(["", ";font-size:10px;line-height:18px;letter-spacing:0.5px;", ";"], baseAllCapsStyles, generateTypographyDefaultColorCSS('allCaps4'));
export var typographyTypeStyleMap = {
  display1Styles,
  display2Styles,
  display3Styles,
  display4Styles,
  display5Styles,
  display6Styles,
  display7Styles,
  display8Styles,
  heading1Styles,
  heading2Styles,
  heading3Styles,
  heading4Styles,
  heading5Styles,
  heading6Styles,
  heading7Styles,
  heading8Styles,
  heading9Styles,
  heading10Styles,
  heading11Styles,
  allCaps1Styles,
  allCaps2Styles,
  allCaps3Styles,
  allCaps4Styles,
  body1Styles,
  body2Styles,
  body3Styles,
  body4Styles,
  body5Styles,
  body6Styles,
  body7Styles
};